import React from "react";
import styled from "styled-components";
// Components
import FullButton from "../Buttons/FullButton";
import AnimateOnScroll from "../AnimateOnScroll";
// Assets
import AddImage2 from "../../assets/img/image3.png";

export default function Projects() {
  return (
    <Wrapper id="projects">
        <div className="container">
          <Advertising className="flexSpaceCenter">
            <AddLeft>
              <AnimateOnScroll animation="fadeRight" delay={0} duration={1000}>
                <AddLeftInner>
                  <ImgWrapper className="flexCenter">
                    <img className="radius8" src={AddImage2} alt="AFRIQ Students" />
                  </ImgWrapper>
                </AddLeftInner>
              </AnimateOnScroll>
            </AddLeft>
            <AddRight>
              <AnimateOnScroll animation="fadeLeft" delay={200} duration={1000}>
                <div>
                  <h4 className="font15 semiBold" style={{fontSize: 'clamp(0.875rem, 2vw, 0.938rem)'}}>Join Our Success Stories</h4>
                  <h2 className="font40 extraBold" style={{fontSize: 'clamp(1.75rem, 4vw, 2.5rem)', lineHeight: '1.3'}}>Your Journey Starts Here</h2>
                  <p className="font15" style={{fontSize: 'clamp(0.9rem, 2vw, 0.938rem)', lineHeight: '1.7'}}>
                    At AFRIQ Bamenda, we don't just prepare students for exams – we prepare them for life. 
                    Our comprehensive programs, expert mentorship, and scholarship opportunities create pathways 
                    to success in professional fields across Cameroon and beyond.
                  </p>
                  <AnimateOnScroll animation="scaleUp" delay={400} duration={800}>
                    <StatsRow style={{ margin: "30px 0" }}>
                      <StatItem>
                        <StatNumber className="font25 extraBold purpleColor">500+</StatNumber>
                        <StatLabel className="font13">Students Prepared</StatLabel>
                      </StatItem>
                      <StatItem>
                        <StatNumber className="font25 extraBold purpleColor">85%</StatNumber>
                        <StatLabel className="font13">Success Rate</StatLabel>
                      </StatItem>
                      <StatItem>
                        <StatNumber className="font25 extraBold purpleColor">50+</StatNumber>
                        <StatLabel className="font13">Scholarships Awarded</StatLabel>
                      </StatItem>
                    </StatsRow>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation="fadeUp" delay={600} duration={800}>
                    <ButtonsRow className="flexNullCenter" style={{ margin: "30px 0" }}>
                      <div style={{ width: "190px" }}>
                        <FullButton title="Apply Now" to="/apply" />
                      </div>
                      <div style={{ width: "190px", marginLeft: "15px" }}>
                        <FullButton title="Learn More" action={() => alert("Learn more about AFRIQ")} border />
                      </div>
                    </ButtonsRow>
                  </AnimateOnScroll>
                </div>
              </AnimateOnScroll>
            </AddRight>
          </Advertising>
        </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 120px 0;
  background: #4b2e83;
  
  @media (max-width: 768px) {
    padding: 80px 0;
  }
  
  @media (max-width: 480px) {
    padding: 60px 0;
  }
`;
const Advertising = styled.div`
  padding: 120px 0;
  margin: 0;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 40px;
    padding: 80px 0;
  }
  
  @media (max-width: 768px) {
    padding: 60px 0;
    gap: 30px;
  }
  
  @media (max-width: 480px) {
    padding: 50px 0;
    gap: 25px;
  }
`;
const ButtonsRow = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin-top: 30px;
  
  @media (max-width: 1024px) {
    justify-content: center;
  }
  
  @media (max-width: 640px) {
    flex-direction: column;
    gap: 12px;
    margin-top: 25px;
    
    > div {
      width: 100%;
    }
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 55%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 45%;
  color: white;
  
  h2, h4, p {
    color: white;
  }
  
  @media (max-width: 860px) {
    width: 100%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative;
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 10%;
  img {
    width: 100%;
    height: auto;
  }
  
  @media (min-width: 1024px) {
    padding: 0 5%;
  }
  
  @media (max-width: 400px) {
    padding: 0;
  }
`;

const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  width: 100%;
  
  @media (max-width: 960px) {
    gap: 15px;
  }
  
  @media (max-width: 560px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    gap: 10px;
    width: 100%;
  }
`;

const StatItem = styled.div`
  text-align: center;
  padding: 30px 20px;
  background: rgba(75, 46, 131, 0.25);
  backdrop-filter: blur(25px);
  border-radius: 16px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  transition: all 0.3s ease;
  color: white;
  width: 100%;
  
  @media (max-width: 768px) {
    padding: 20px 12px;
    border-radius: 14px;
  }
  
  @media (max-width: 560px) {
    padding: 18px 10px;
    border-radius: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 15px 8px;
    border-radius: 10px;
  }
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
  }
`;

const StatNumber = styled.div`
  margin-bottom: 10px;
  font-size: clamp(1.5rem, 4vw, 2.5rem);
  font-weight: 900;
  color: white;
  line-height: 1;
  
  @media (max-width: 560px) {
    font-size: clamp(1.2rem, 3.5vw, 1.8rem);
    margin-bottom: 6px;
  }
  
  @media (max-width: 480px) {
    font-size: clamp(1rem, 3vw, 1.5rem);
    margin-bottom: 5px;
  }
`;

const StatLabel = styled.div`
  color: rgba(255, 255, 255, 0.9);
  font-size: clamp(0.7rem, 1.5vw, 0.813rem);
  
  @media (max-width: 560px) {
    font-size: clamp(0.65rem, 1.3vw, 0.75rem);
  }
  
  @media (max-width: 480px) {
    font-size: clamp(0.6rem, 1.2vw, 0.7rem);
  }
`;
